import { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { getCustomSegmentsMetadata } from "app/pages/segments/config/segmentsConfigHelpers";

import { dashboardWizardKeyReset, segmentsGroupIdChanged } from "../../actions/dashboardWizardActionCreators";

import SegmentsDropdown from "./components/SegmentsDropdown/SegmentsDropdown";
import SegmentGroupsDropdown from "./components/SegmentsGroupDropdown/SegmentGroupsDropdown";
import { MAX_SEGMENTS_COUNT, PLACEHOLDER_SIZE } from "./constants";
import useSegments from "./hooks/useSegments";
import { selectAccountSegments, selectCustomSegmentsGroups, selectWidgetFilters } from "./selectors";
import { DropdownContainer, DropdownWrapper, SegmentsTitleWrapper, SelectedItemsCount } from "./styles";

const SegmentDropdowns = ({ customDashboard }) => {
    const dispatch = useDispatch();

    const {
        setGroupId,
        setSelectedSegmentsId,
        segments,
        selectedGroupId,
        selectedSegmentsIds,
        segmentsGroupsWithFlags,
        selectedSegments,
    } = useSegments(customDashboard);

    const accountSegments = useSelector(selectAccountSegments);
    const widgetFilters = useSelector(selectWidgetFilters);
    const segmentsGroups = useSelector(selectCustomSegmentsGroups);

    const [isMetadataLoading, setIsMetadataLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setIsMetadataLoading(true);
            try {
                if (!accountSegments || !segmentsGroups) {
                    dispatch(dashboardWizardKeyReset(customDashboard));
                    await getCustomSegmentsMetadata();
                }
            } finally {
                setIsMetadataLoading(false);
            }
            dispatch(segmentsGroupIdChanged(customDashboard, selectedGroupId));
        })();
    }, []);

    return (
        <>
            <h4>{translate("wizard.segments.group.dropdown.comparisons.title")}</h4>
            <DropdownWrapper>
                {!isMetadataLoading ? (
                    <SegmentGroupsDropdown
                        setSelectedGroupId={setGroupId}
                        segmentsGroups={segmentsGroupsWithFlags}
                        selectedGroupId={selectedGroupId}
                    />
                ) : (
                    <DropdownContainer>
                        <PixelPlaceholderLoader
                            width={PLACEHOLDER_SIZE.width}
                            height={PLACEHOLDER_SIZE.heigth}
                        />
                    </DropdownContainer>
                )}
            </DropdownWrapper>
            <SegmentsTitleWrapper>
                <h4>{translate("wizard.segments.group.dropdown.website.title")}</h4>
                <SelectedItemsCount isMaxReached={widgetFilters?.selectedSegmentsId?.length >= MAX_SEGMENTS_COUNT}>
                    {`${widgetFilters?.selectedSegmentsId?.length || 0}/${MAX_SEGMENTS_COUNT}`}
                </SelectedItemsCount>
            </SegmentsTitleWrapper>
            <DropdownWrapper>
                {!isMetadataLoading ? (
                    <SegmentsDropdown
                        selectedSegments={selectedSegments}
                        selectedSegmentsIds={selectedSegmentsIds}
                        setSelectedSegmentsId={setSelectedSegmentsId}
                        segments={segments}
                    />
                ) : (
                    <DropdownContainer>
                        <PixelPlaceholderLoader
                            width={PLACEHOLDER_SIZE.width}
                            height={PLACEHOLDER_SIZE.heigth}
                        />
                    </DropdownContainer>
                )}
            </DropdownWrapper>
        </>
    );
};

export default SegmentDropdowns;
